import styled from 'styled-components';
import { CardColumn, CardSection } from '../CardsStyledComponents';
import { TextBold } from '../../../styles/GlobalStyledComponents';

export const CardPaymentSection = styled(CardSection)`
  width: 100%;
  justify-content: space-between;

  @media (max-width: 420px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
`;

export const CardPaymentColumn = styled(CardColumn)`
  gap: 4px;
`;

export const AmountSection = styled(CardSection)``;

export const TextBoldAmount = styled(TextBold)`
  padding-top: 2px;
`;
